import {Box} from 'platform/foundation';

import {Main} from '@dms/shared';

import {useRequiredParams} from 'shared/web';

import {CustomerMessageHistory} from './components/CustomerMessageHistory/CustomerMessageHistory';

export function CustomerMessageHistoryVisualDebug() {
  const {id} = useRequiredParams();

  return (
    <Box flexGrow={1}>
      <Main>
        <CustomerMessageHistory customerId={id} />
      </Main>
    </Box>
  );
}
